<script lang="ts">
	export let title = '';
	export let as: 'link' | 'button' = 'button';
	export let linkTo: string;

	let className;
	export { className as class };
</script>

{#if as === 'button'}
	<button class={`more-btn ${className || ''}`} type="button" on:click>{title}</button>
{:else}
	<a href={linkTo} class="more-btn">{title}</a>
{/if}

<style lang="scss">
	@import 'moreBtn';
</style>
